import React from "react";
import { formatPresenceTimestamp } from "../../features/presence/lib/formatPresence";

function ProfileIdentity({ name, isOnline, lastSeen }) {
  const showOnline = isOnline === true;
  const showLastSeen = isOnline === false && Boolean(lastSeen);
  const statusKnown = showOnline || showLastSeen;
  const headClass = "profile-card__head"
    + (showOnline ? " is-online" : "")
    + (showLastSeen ? " is-offline" : "");
  const lastSeenText = showLastSeen ? formatPresenceTimestamp(lastSeen) : "";
  return (
    <header className={headClass}>
      <h1 className="profile-card__name">{name}</h1>
      {statusKnown && (
        <p className="profile-card__status">
          {showOnline ? (
            <span className="profile-card__status--online">
              <span className="profile-card__status-dot" aria-hidden="true"></span>
              Онлайн
            </span>
          ) : (
            <span className="profile-card__status--offline">
              Востаннє в мережі {lastSeenText}
            </span>
          )}
        </p>
      )}
    </header>
  );
}

export default ProfileIdentity;
